<template>
    <div class="shop-cart">
        <template v-if="orderComplete">
            <shop-headline :headline="$t('orderComplete.headline')"/>
        </template>
        <template v-else>
            <shop-headline :headline="$t('cart')" icon="cart"/>
        </template>

        <template v-if="orderComplete">
            <p v-html="$t('orderComplete.paragraph1')"></p>
            <p v-html="$t('orderComplete.paragraph2')"></p>
            <p><b v-html="$t('orderComplete.paragraph3')"></b></p>
        </template>
        <template v-else-if="isEmpty">
            <shop-info-box>
                <template v-slot:info-area>
                    <p v-html="$t('isEmpty')"></p>
                </template>
            </shop-info-box>
            <p v-html="$t('emptyNotice')"></p>
            <shop-login :buttons="buttons" v-slot:body v-if="!authenticated">
                <template>
                    <h3>{{ $t('login.headline') }}</h3>
                    <p v-html="$t('login.body')"></p>
                </template>
            </shop-login>
        </template>
        <template v-else>
            <shop-info-box v-if="$t('infoBanner.paragraph1').length">
                <template v-slot:info-area>
                    <p v-html="$t('infoBanner.paragraph1')"></p>
                    <p v-html="$t('infoBanner.paragraph2')"></p>
                    <p v-html="$t('infoBanner.paragraph3')"></p>
                    <p v-html="$t('infoBanner.paragraph4')"></p>
                    <p v-html="$t('infoBanner.paragraph5')"></p>
                </template>
            </shop-info-box>
            <shop-section v-if="!authenticated">
                <template v-slot:headline>{{$t('login.headline')}}</template>
                <shop-login :buttons="buttons" v-slot:body>
                    <template>
                        <h3>{{ $t('login.headline') }}</h3>
                        <p v-html="$t('login.body')"></p>
                    </template>
                </shop-login>
            </shop-section>
            <shop-section v-if="authenticated">
                <template v-slot:preamble>
                    <span v-html="replacedMaxItemsNotice"></span>
                </template>
            </shop-section>
            <template v-for="(section, sectionIndex) in cartData.items">
                <shop-section v-if="section.items.length">
                    <template v-slot:headline>
                        {{ section.sectionTitle }}
                    </template>

                    <template v-slot:body>
                        <shop-fanbox v-if="showFanboxOption && section.category === 'faecher'" :items="section.items" :max-order-items="section.maxOrderItems" />
                        <div class="row" v-else>
                            <template v-if="section.category === 'product_samples'">
                                <PimProductTableListSamples :samples="section.items" class="col-12">
                                    <template v-slot:actions="actionProps">
                                        <div class="ordercount-input" :class="[cartData?.items[sectionIndex]?.items[actionProps.index].orderQuantityError ? 'has-error': 'no-error']">
                                            <global-item-quantity
                                                v-show="authenticated"
                                                @updateErrorItemQuantity="$event ? $store.dispatch('addCartErrorItem', actionProps.item.pim_id) : $store.dispatch('removeCartErrorItem', actionProps.item.pim_id)"
                                                @updateCartData="$store.dispatch('changeCartOrderQuantity', {pim_id: actionProps.item.pim_id, quantity: $event})"
                                                :min="1"
                                                :value="$store.getters.cartGetCartOrderQuantityForPimId(actionProps.item.pim_id)"
                                                :max="maxOrderQuantityForItem(actionProps.item, parseInt(section.maxOrderItems))"
                                                :error-messages="{errorToSmall: $t('errorItemQuantityMin'), errorToLarge: $t('errorItemQuantityMax'), errorNotANumber: $t('errorItemQuantityEmpty')}"
                                            >
                                                <template v-slot:amount>{{ $t('orderquantity') }}</template>
                                            </global-item-quantity>
                                            <div class="button-wrapper v-center spaced--narrow right">
                                                <wishlist-button :entity="actionProps.item"/>
                                                <global-button @click="remove(actionProps.item.pim_id)" icon="trash" theme="secondary"/>
                                            </div>
                                        </div>
                                    </template>
                                </PimProductTableListSamples>
                            </template>
                            <template v-else-if="section.category === 'material_samples'">
                                <PimProductTableListInformationMaterial :materials="section.items" class="col-12">
                                    <template v-slot:actions="actionProps">
                                        <div class="ordercount-input" :class="[cartData?.items[sectionIndex]?.items[actionProps.index].orderQuantityError ? 'has-error': 'no-error']">
                                            <global-item-quantity
                                                v-show="authenticated"
                                                @updateErrorItemQuantity="$event ? $store.dispatch('addCartErrorItem', actionProps.item.pim_id) : $store.dispatch('removeCartErrorItem', actionProps.item.pim_id)"
                                                @updateCartData="$store.dispatch('changeCartOrderQuantity', {pim_id: actionProps.item.pim_id, quantity: $event})"
                                                :min="1"
                                                :value="$store.getters.cartGetCartOrderQuantityForPimId(actionProps.item.pim_id)"
                                                :max="maxOrderQuantityForItem(actionProps.item, parseInt(section.maxOrderItems))"
                                                :error-messages="{errorToSmall: $t('errorItemQuantityMin'), errorToLarge: $t('errorItemQuantityMax'), errorNotANumber: $t('errorItemQuantityEmpty')}"
                                            >
                                                <template v-slot:amount>{{ $t('orderquantity') }}</template>
                                            </global-item-quantity>
                                            <div class="button-wrapper v-center spaced--narrow right">
                                                <wishlist-button :entity="actionProps.item"/>
                                                <global-button @click="remove(actionProps.item.pim_id)" icon="trash" theme="secondary"/>
                                            </div>
                                        </div>
                                    </template>
                                </PimProductTableListInformationMaterial>
                            </template>
                            <template v-else v-for="(item, itemIndex) in section.items">
                                <shop-tile :tile="item" class="col-12 col-md-6" :key="item.order_pid">
                                    <template v-slot:button-add2wishlist>
                                        <span class="wish-list link link--primary link--icon icon--small icon--before icon--wishlist-empty"
                                              :data-pid="item.order_pid"
                                              :data-title="item.title"
                                              :data-titlesuffix="item.titlesuffix"
                                              :data-subtitle="item.subtitle"
                                              :data-subsubtitle="item.subsubtitle">
                                        </span>
                                    </template>
                                    <template v-slot:ordercount>
                                        <div class="col-12 ordercount-input"
                                             :class="[cartData.items[sectionIndex].items[itemIndex].orderQuantityError ? 'has-error': 'no-error']">
                                            <global-item-quantity
                                                @updateErrorItemQuantity="$event ? $store.dispatch('addCartErrorItem', item.pim_id) : $store.dispatch('removeCartErrorItem', item.pim_id)"
                                                @updateCartData="$store.dispatch('changeCartOrderQuantity', {pim_id: item.pim_id, quantity: $event})"
                                                :min="1"
                                                :value="$store.getters.cartGetCartOrderQuantityForPimId(item.pim_id)"
                                                :max="maxOrderQuantityForItem(item, parseInt(section.maxOrderItems))"
                                                :error-messages="{errorToSmall: $t('errorItemQuantityMin'), errorToLarge: $t('errorItemQuantityMax'), errorNotANumber: $t('errorItemQuantityEmpty')}"
                                            >
                                                <template v-slot:amount>{{ $t('orderquantity') }}</template>
                                            </global-item-quantity>
                                            <global-button @click="remove(item.pim_id)" icon="trash" theme="secondary"/>

                                        </div>
                                    </template>
                                    <template v-slot:remove-button>
                                        <div class="button-wrapper spacer--top" v-show="authenticated === false">
                                            <global-button @click="remove(item.pim_id)" icon="trash" theme="secondary"/>
                                        </div>
                                    </template>
                                </shop-tile>
                            </template>
                        </div>
                    </template>
                </shop-section>
            </template>
            <shop-section v-if="!authenticated && !isEmpty">
                <shop-login :buttons="buttons" v-slot:body>
                    <template>
                        <h3>{{ $t('login.headline') }}</h3>
                        <p v-html="$t('login.body')"></p>
                    </template>
                </shop-login>
            </shop-section>
            <shop-section v-if="authenticated" class="shop-section--border">
                <template v-slot:body>
                    <div class="row">
                        <div class="col-12 col-md-6">
                            <p v-if="alternateAddress"><b v-html="$t('checkout.invoiceAddress')"></b></p>
                            <p v-else><b v-html="$t('checkout.deliveryInvoiceAddress')"></b></p>
                            <address class="address">
                                <span v-if="userAddress.company">{{ userAddress.company }}</span>
                                <span>{{ userAddress.firstName }} {{ userAddress.lastName }}</span>
                                <span v-if="userAddress.street">{{ userAddress.street }}</span>
                                <span class="spacer">
                                    <span>{{ userAddress.postCode }} {{ userAddress.city }}</span>
                                    <span>{{ countryByKey[userAddress.country] }}</span>
                                </span>
                                <span v-if="userAddress.phone.length" class="spacer">
                                    <span>{{ $t('checkout.labels.tel') }} {{ userAddress.phone }}</span>
                                </span>
                            </address>
                        </div>
                        <div class="col-12 col-md-6">
                            <shop-alternate-address ref="alternateAddress" @alternateAddress="setAlternateAddress($event.detail)" :show="showAlternateAddress"
                                                    @close="showAlternateAddress = false" :user-address="userAddress"/>
                            <template>
                                <shop-info-box>
                                    <template v-slot:info-area>
                                        <p v-html="$t('checkout.alternateAddressNotice')"></p>
                                    </template>
                                    <template v-slot:cta-area>
                                        <div class="button-wrapper bottom left">
                                            <button class="button button--primary" @click="showAlternateAddress = true"
                                                    v-html="$t('checkout.alternateAddress')">
                                            </button>
                                        </div>
                                    </template>
                                </shop-info-box>
                            </template>
                        </div>
                        <div v-if="alternateAddress && address.mainAddress === false" class="col-12 col-md-6">
                            <p><b v-html="$t('checkout.deliveryAddress')"></b></p>
                            <address class="address">
                                <span v-if="address.company">{{ address.company }}</span>
                                <span>{{ address.firstName }} {{ address.lastName }}</span>
                                <span v-if="address.street">{{ address.street }}</span>
                                <span class="spacer">
                                    <span>{{ address.postCode }} {{ address.city }}</span>
                                    <span>{{ countryByKey[address.country] }}</span>
                                </span>
                                <span v-if="userAddress.phone.length" class="spacer">
                                    <span>{{ $t('checkout.labels.tel') }} {{ address.phone }}</span>
                                </span>
                            </address>
                        </div>
                        <div class="col-12">
                            <shop-info-box>
                                <template v-slot:info-area>
                                    <h3 v-html="$t('checkout.objectNameInfoHeadline')"/>
                                    <p v-html="$t('checkout.objectNameInfoBody')"/>
                                    <div class="form-group">
                                        <label class="form__label" for="objectName">{{ $t('checkout.objectNameInputLabel') }}</label>
                                        <input class="form__input form__input--text form--light col-md-6" v-model="objectName" type="text" maxlength="22"
                                               id="objectName">
                                    </div>
                                </template>
                            </shop-info-box>
                        </div>
                    </div>
                </template>
            </shop-section>
            <shop-section>
                <div class="form-group has-error">
                    <template v-for="value in Object.values(backendErrors)">
                        <p class="form__error" v-if="value !== ''">{{ value }}</p>
                    </template>
                </div>
            </shop-section>
            <global-input-checkbox v-if="!isEmpty && authenticated" :label="$t('checkout.customs.label')" show-required-star="true"
                                   :error="customsChecked === false ? $t('checkout.customs.error') : null" @input="customsChecked = $event"/>
            <shop-checkout-button class="shop-checkout__button--bottom"
                                  v-if="!isEmpty && authenticated"
                                  @order="requestOrder"
                                  :showErrorMessage="false"
                                  :orderItemCount="orderItemCount"
                                  :newsletterlabel="$t('checkout.newsletterLabel')"
                                  :newsletteruri="$t('checkout.newsletterUri')"
                                  :shopDisabled="shopDisabled">
                <template v-slot:button-label>
                    <span v-html="$t('checkout.order')"></span>
                </template>
            </shop-checkout-button>
        </template>
    </div>
</template>

<script>
import ShopSection from "@shopCheckout/components/shop-section/shop-section.vue";
import ShopCheckoutButton from "@shopCheckout/components/shop-checkout-button/shop-checkout-button";
import ShopInfoBox from "@shopCheckout/components/shop-info-box/shop-info-box";
import ShopTile from "@shopCheckout/components/shop-tile/shop-tile";
import {shopUtilities, WISHLIST} from "@global/shop-utilities/shop-utilities";
import {cookieUtils} from "@utilities/cookie-utils/cookie-utils";
import ShopLogin from "@shopCheckout/components/shop-login/shop-login";
import ShopHeadline from "@shopCheckout/components/shop-headline/shop-headline";
import ShopItemQuantity from "@shopCheckout/components/shop-item-quantity/shop-item-quantity";
import GlobalButton from "@global/global-elements/global-button/global-button";
import GlobalItemQuantity from "@global/global-elements/global-item-quantity/global-item-quantity";
import ShopAlternateAddress from "@shopCheckout/components/shop-alternate-address/shop-alternate-address";
import ShopFanbox from "../../components/shop-fanbox/shop-fanbox";
import GlobalInputCheckbox from "@global/global-elements/global-input-checkbox/global-input-checkbox";
import PimProductTableListSamples from "@src/Resources/epim/Partials/PimProductTableList/pim-product-table-list-samples.vue";
import PimProductTableListInformationMaterial from "@src/Resources/epim/Partials/PimProductTableList/pim-product-table-list-information-material.vue";
import CartButton from "@src/Resources/epim/Partials/Shop/cart-button.vue";
import WishlistButton from "@src/Resources/epim/Partials/Shop/wishlist-button.vue";

export default {
    name: "shop-cart",
    components: {
        WishlistButton,
        CartButton,
        PimProductTableListInformationMaterial, PimProductTableListSamples,
        GlobalInputCheckbox,
        ShopFanbox,
        ShopAlternateAddress,
        GlobalItemQuantity,
        ShopItemQuantity, ShopLogin, ShopTile, ShopInfoBox, ShopCheckoutButton, ShopSection, ShopHeadline, GlobalButton
    },
    data() {
        return {
            customsChecked: undefined,
            showErrors: false,
            errorItemQuantity: false,
            orderComplete: false,
            alternateAddress: false,
            showAlternateAddress: false,
            objectName: '',
            address: {
                firstName: '',
                lastName: '',
                company: '',
                street: '',
                postCode: '',
                city: '',
                country: ''
            },
            item: {
                maxOrderItemsExceed: {
                    value: '',
                    error: false,
                    backendError: false
                }
            },
            errors: {
                general: '',
                firstName: '',
                lastName: '',
                street: '',
                postCode: '',
                city: '',
                country: '',
                maxOrderItemsExceed: ''

            },
            backendErrors: {
                technical: '',
                general: '',
                firstName: '',
                lastName: '',
                street: '',
                postCode: '',
                city: '',
                country: ''
            }
        }
    },
    computed: {
        cartData() {
            return this.$store.state.cartData
        },
        authenticated() {
            return this.$store.getters.authenticated;
        },
        shopDisabled() {
            return !window.shopenabled
        },
        fanboxThreshold() {
            return this.$store.state.cartFanboxThreshold
        },
        showFanboxOption() {
            return this.$store.getters.cartShowFanboxOption
        },
        buttons() {
            return [
                {link: window.cartdata.login, label: this.$t('login.login')},
                {link: window.cartdata.register, label: this.$t('login.register')}
            ]
        },
        errorsInForm() {
            const keys = Object.keys(this.address);
            return keys.some(key => this.address[key]["error"]);
        },
        countryByKey() {
            return this.$store.getters.countries;
        },
        isEmpty() {
            return this.$store.getters.cartIsEmpty;
            // return this.cartData.items === null || this.cartData.items.length === 0
        },
        userAddress() {
            return window.cartdata.address
        },
        orderItemCount() {
            return this.$store.getters.cartOrderItemCount;
            // return this.cartData.items.reduce((sum, item) => sum + item.items.length, 0);
        },
        replacedMaxItemsNotice() {
            let text = this.$t('fullNotice');

            const max = window.wishcart_orderMaxItems;
            const count = this.orderItemCount;
            text = text.replace(/MAX/, max);
            text = text.replace(/COUNT/, count);
            text = text.replace(/DELTA/, count > max ? count - max : '');

            return text;
        },
    },
    methods: {
        maxOrderQuantityForItem(item, sectionMax) {
            if (item.ordernumber === window.cartdata.fanboxId) {
                return 1;
            }
            return sectionMax;
        },
        setAlternateAddress(address) {
            this.alternateAddress = true;
            this.address = Object.assign({}, this.address, address)
        },
        remove(pim_id) {
            this.$store.dispatch('changeCartOrderQuantity', {pim_id: pim_id, quantity: 0})
        },
        requestOrder() {
            if (!this.authenticated) {
                return
            }

            if (!this.customsChecked) {
                this.customsChecked = false;
                return;
            }

            this.errorItemQuantity = !!this.$store.state.cartErrorItems.length

            // hole alle items aus cartdata und erzeuge neuen cookieString mit angehaengter Bestellmenge
            // let newCookieValues = [];
            // this.errorItemQuantity = false;
            // for ( let items in cartdata.items){
            //     for ( let itemsitems in cartdata.items[items].items){
            //         newCookieValues.push(cartdata.items[items].items[itemsitems].order_pid + '#' + cartdata.items[items].items[itemsitems].orderQuantity);
            //         // wenn irgendwo ein Fehler ist ...
            //         if(cartdata.items[items].items[itemsitems].orderQuantityError) this.errorItemQuantity = true;
            //     }
            // }


            // let newCookieValueString = newCookieValues.join('$');
            // // Cookie ersetzen
            // let cookieKey = this.cartData.cookieKey;
            // let cookieValue = cookieUtils.getCookie(cookieKey);
            // //cookie neu setzen
            // cookieUtils.setCookie(cookieKey, newCookieValueString);


            let data = new FormData();

            data.append("cartOrderQuantity", JSON.stringify(this.$store.state.cartOrderQuantity))
            data.append("convertToFanbox", (this.showFanboxOption && this.$store.state.cartSelectFanbox) ? "true" : "false")
            data.append("customsAccepted", this.customsChecked ? "true" : "false");

            if (this.alternateAddress) {
                data.append("alternate", 1)
                data.append("firstName", this.address.firstName);
                data.append("lastName", this.address.lastName);
                if (this.address.company.length) {
                    data.append("company", this.address.company);
                }
                data.append("street", this.address.street);
                data.append("postCode", this.address.postCode);
                data.append("city", this.address.city);
                data.append("country", this.address.country);
                data.append('phone', this.address.phone);
                this.showErrors = this.errorsInForm
            }

            if (this.objectName !== '') {
                data.append('objectName', this.objectName)
            }

            // wenn kein Fehler in AdressForm oder in Item-Mengen
            if (!this.errorsInForm && !this.errorItemQuantity) {
                this.$store.dispatch('setFreeze', true);
                fetch(window.checkout, {
                    method: 'POST',
                    cache: 'no-cache',
                    credentials: 'same-origin',
                    body: data
                }).then(response => {
                    response.text()
                        .then(message => {
                            const parsedMessage = JSON.parse(message);
                            let errors = [];
                            if (parsedMessage.errors) {
                                errors = parsedMessage.errors
                            }
                            const errorKeys = Object.keys(errors);
                            if (errorKeys.length > 0) {
                                this.showErrors = true;
                                this.orderComplete = false;
                                Object.assign(this.backendErrors, errors);

                                this.$store.dispatch('setFreeze', false);
                            } else {
                                // success.... :-o
                                if (this.alternateAddress)
                                    this.$refs.alternateAddress.saveLastUsed(this.address.id)

                                if (typeof window.gtag === 'function') {
                                    let gtag_items = [];
                                    this.cartData.items.forEach(section => {
                                        section.items.forEach(item => {
                                            gtag_items.push({
                                                "id": item.order_pid.split('#')[1],
                                                "name": item.title + ' ' + item.subtitle + ' ' + (item.subsubtitle || ''),
                                                "category": item.order_pid.split('#')[0],
                                                "quantity": this.$store.state.cartOrderQuantity[item.order_pid.split('#')[1]] || 1,
                                                "price": '0'
                                            });
                                        });
                                    });
                                    window.gtag('event', 'purchase', {
                                        "transaction_id": Date.now(),
                                        "affiliation": "Mustershop",
                                        "value": 0,
                                        "currency": "EUR",
                                        "tax": 0,
                                        "shipping": 0,
                                        "items": gtag_items
                                    });
                                    // Hash = to.path
                                    let page_location = window.location.href.substring(0, window.location.href.indexOf('#'));
                                    let page_path = window.location.pathname;
                                    // Check if they end with / and add one if needed
                                    page_location += page_location.lastIndexOf('/') === page_location.length - 1 ? '' : '/';
                                    page_path += page_path.lastIndexOf('/') === page_path.length - 1 ? '' : '/';
                                    // Add router path
                                    page_location += 'virtual/purchased';
                                    page_path += 'virtual/purchased';
                                    window.promised_gtag.then((gtag) => {
                                        gtag('event', 'page_view', {
                                            page_location: page_location,
                                            page_path: page_path
                                        });
                                    });
                                }
                                if (window.pintrk) {
                                    window.pintrk('track', 'checkout', {
                                        value: 0,
                                        order_quantity: this.cartData.items.length,
                                        currency: 'EUR'
                                    });
                                }

                                cookieUtils.deleteCookie('cart_' + window.market);
                                cookieUtils.deleteCookie('cart_' + window.market + '_quantity');
                                shopUtilities.broadcastChanges('cartdeleted', {});

                                // Falls gewünscht muss man noch parsedMessage.orderInBudget verarbeiten und eine andere Meldung anzeigen
                                this.orderComplete = true;
                                this.$store.dispatch('setFreeze', false);
                                window.scrollTo(0, 0); // weil ichs kann ;-O
                            }
                        })
                }).catch(error => {
                    // Kein unfreeze, da ist was im argen... this.$store.dispatch('setFreeze', false);
                    this.backendErrors.technical = 'The backend is broken. Please reload this page and try again.';
                    console.error("Post error: ", error)
                });
            }
        },
    },
    beforeMount() {
        if (window.cartdata) {
            this.$store.dispatch('setCartData', window.cartdata)

            if (window.cartdata.items) {
                for (const category of window.cartdata.items) {
                    if (category.items) {
                        for (const item of category.items) {
                            const existingQuantity = shopUtilities.getQuantity('cart', item.pim_id)

                            if (existingQuantity) {
                                this.$store.dispatch("changeCartOrderQuantity", {pim_id: item.pim_id, quantity: existingQuantity})
                            } else {
                                this.$store.dispatch("changeCartOrderQuantity", {pim_id: item.pim_id, quantity: 1})
                            }
                        }
                    }
                }
            }

            if (window.cartdata.fanboxThreshold) {
                this.$store.dispatch('setCartFanboxThreshold', window.cartdata.fanboxThreshold);
            }

            if (window.cartdata.fanboxItems) {
                this.$store.dispatch('setCartFanboxItems', window.cartdata.fanboxItems)
            }
        }
    },
    mounted() {
        this.errors.general = this.$t('checkout.errors.general');
        this.errors.firstName = this.$t('checkout.errors.firstName');
        this.errors.lastName = this.$t('checkout.errors.lastName');
        this.errors.street = this.$t('checkout.errors.street');
        this.errors.postCode = this.$t('checkout.errors.postCode');
        this.errors.city = this.$t('checkout.errors.city');
        this.errors.country = this.$t('checkout.errors.country');

        const wishlistItems = document.querySelectorAll(`.shop-cart .${shopUtilities.options.wishlist.class}`);
        wishlistItems.forEach(item => {
            shopUtilities.registerListeners(item, WISHLIST);
        });
    }
}
</script>
